export default __webpack_public_path__ + "static/media/ira4.8e3bc9be.jpg";